/** The header's date (Home spec §4; SA-475 §13 FF5): the deployment's day,
 * re-read every minute so an open page turns over within a minute of the
 * deployment's midnight. Its own component, so only this line re-renders on
 * the tick. */
import { useEffect, useState } from 'react'
import { todayText } from './homeWords'

export const TODAY_TICK_MS = 60_000

export function TodayLine({ zone }: { zone: string }) {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), TODAY_TICK_MS)
    return () => clearInterval(id)
  }, [])
  return <p className="mt-0.5">{todayText(now, zone)}</p>
}
